import React from 'react'
import { Button } from 'transfix-ui/components/Button/Button'
import { Box, makeStyles, Typography } from 'transfix-ui/core'

const useStyles = makeStyles({
  overlay: {
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    position: 'absolute',
    background: '#00000044',
    zIndex: 1,
  },
  popup: {
    position: 'absolute',
    borderRadius: '8px 8px 0 0',
    boxShadow: '0px 0px 24px 0px #00000026',
    bottom: '0',
    left: '0',
    right: '0',
    padding: '16px',
    paddingTop: '24px',
    background: '#ffffff',
  },
  buttonsContainer: {
    paddingTop: '24px',
    paddingBottom: '8px',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    margin: '0 auto',
    maxWidth: '600px',
  },
})

interface ITrailerNumberPrompt {
  clickHandler: () => void
  setShowTrailerPrompt: (val: boolean) => void
  submitInOutFormHandler: () => Promise<true | undefined>
}

const TrailerNumberPrompt = ({
  clickHandler,
  setShowTrailerPrompt,
  submitInOutFormHandler,
}: ITrailerNumberPrompt) => {
  const closeTrailerPrompt = () => setShowTrailerPrompt(false)
  const acceptHandler = async () => {
    await submitInOutFormHandler().then(response => {
      if (response === undefined) {
        return closeTrailerPrompt()
      }
      clickHandler()
      return closeTrailerPrompt()
    })
  }

  const declineHandler = () => {
    submitInOutFormHandler()
    closeTrailerPrompt()
  }

  const cancelHandler = () => {
    closeTrailerPrompt()
  }

  const classes = useStyles()
  return (
    <Box onClick={cancelHandler} className={classes.overlay}>
      <div className={classes.popup}>
        <Typography align='center'>Do you know the trailer number?</Typography>
        <div className={classes.buttonsContainer}>
          <Button fullWidth color='tertiary' size='large' onClick={declineHandler} data-test='no'>
            No
          </Button>
          <Button color='primary' fullWidth size='large' onClick={acceptHandler} data-test='yes'>
            Yes
          </Button>
        </div>
      </div>
    </Box>
  )
}

export default TrailerNumberPrompt
